<div class="internal-container">
  <div *ngFor="let item of itemsCarousel" class="internal-container__padd" [ngClass]="{'mobile__items': deviceType == 'mobile','tablet__items' : deviceType == 'tablet'}"
    routerLink="{{item.url}}">
    <div class="internal-container__front">
      <div class="internal-container__background" [style.background-image]="(item?.thumbnail)?'url('+item?.thumbnail+')': ''">
        <div class="internal-container__item">
        </div>
      </div>
      <div class="internal-container__title">
        <h2 class="title">{{item.name}}</h2>
      </div>
    </div>
    <!-- <div class="internal-container__desc">
      {{item.description}}
    </div> -->
    <div class="internal-container__btn">
      <button *ngIf="!isNode" class="" mat-raised-button color="primary">{{'MORE_DETAILS' | translate}}</button>
    </div>
  </div>
  <button [disabled]="btnLess" class='leftRs' (click)="lessItems()"><i class="material-icons" [ngClass]="{'btnDisabled':btnLess}">
      keyboard_arrow_left
    </i></button>
  <button [disabled]="btnMore" class='rightRs' (click)="moreItems()"><i class="material-icons" [ngClass]="{'btnDisabled':btnMore}">
      keyboard_arrow_right
    </i></button>
</div>